export const cacheKeys = {
  getMe: 'getMe',
  deleteMe: 'deleteMe',
};
